import { Button } from '../Input2';
import { General } from '../StrokeIcons';
import Popup, { PopupProps } from './Popup';

type CreateHubspotContactPopupProps = PopupProps & {
  onClose: () => void;
  onDelete: () => void;
};

export default function CreateHubspotContactPopup({ onClose, onDelete }: CreateHubspotContactPopupProps) {
  return (
    <Popup onClose={onClose}>
      <h2 className="text-xl font-bold dark:text-gray-100">Are you sure?</h2>
      <p className="dark:text-gray-300">
        This will <strong>create</strong> another Contact on{' '}
        <General.HubSpotIcon className="relative inline-block size-4 text-[#f7761f]" />
        <strong className="text-[#f7761f]">Hubspot</strong> based on the Poseidon Contact
      </p>
      <Button color="blue" onClick={onDelete}>
        Yes, Create Contact in Hubspot
      </Button>
    </Popup>
  );
}

